import React, { useState, useEffect } from 'react'
import { fetchRateListPage } from '@/lib/api'
import { captureException } from '@sentry/nextjs'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { createResource, useResource } from '@/lib/i18n'
import { setCustomHeaders } from '@/lib/utils'
import { useRouter } from 'next/router'

const GooglePlay = dynamic(import('@/components/common/google-play-btn'))
const AboutBanner = dynamic(import('@/components/about/banner'))
const IntroduceHook = dynamic(import('@/components/about/introduce'))
const Footer = dynamic(import('@/components/home/footer'))
const KPHead = dynamic(import('@/components/head'))
const TopNavigation = dynamic(import('@/components/top-navigation'))
const MoreLoan = dynamic(import('@/components/about/more-loan'))
const RateHook = dynamic(import('@/components/about/rate'))
const Financial = dynamic(import('@/components/about/financial'))
const News = dynamic(import('@/components/about/news'))
const Honours = dynamic(import('@/components/home/honours'))
const AssociatedMedia = dynamic(import('@/components/home/associated-media'))

const resource = createResource({
  en: {
    description: `About Kredit Pintar PT Kredit Pintar Indonesia is a fintech (financial technology) company that has a vision to improve the lives of Indonesians by providing easy access to short-term loans. With leading AI (Artificial Intelligence) technology, we want to work with the community to improve Indonesia's welfare.`,
  },
  id: {
    description: `Tentang Perusahaan Kredit Pintar PT Kredit Pintar Indonesia adalah perusahaan fintech (financial technology ) yang memiliki visi untuk meningkatkan kehidupan masyarakat Indonesia melalui penyediaan akses yang mudah untuk mendapatkan pinjaman jangka pendek. Dengan teknologi AI (Artificial Intelligence) terdepan, kami ingin bekerja sama dengan masyarakat untuk meningkatkan kesejahteraan Indonesia.`,
  },
})
interface IProps {
  rateList: {
    [key: string]: {
      title: string
      imgUrl?: string
      rate: string
    }
  }
}
const AboutUsPage = (props: IProps) => {
  const { t } = useResource(resource)
  const { rateList } = props
  const [isFromeMe, setFromeMe] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const path = router.asPath
    const query = router.query.isFrom || ''
    if (path.includes('about-us') && query === 'me') {
      setFromeMe(true)
    }
  }, [router.asPath])

  return (
    <>
      <KPHead metaTitle="aboutUs" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      {!isFromeMe && <TopNavigation />}
      <AboutBanner />
      <IntroduceHook />
      <News />
      <Honours />
      <AssociatedMedia />
      <MoreLoan />
      <RateHook rateList={rateList} />
      <Financial />
      <Footer />
      {!isFromeMe && <GooglePlay />}
    </>
  )
}

export default AboutUsPage

export const getServerSideProps = async ({ req, res }) => {
  setCustomHeaders(req, res, 'about_us')
  try {
    const result: any = await fetchRateListPage()
    return {
      props: {
        rateList: result?.acf,
      },
    }
  } catch (err) {
    captureException(err)
    return {
      props: { rateList: {} },
    }
  }
}
